import mapboxgl from 'mapbox-gl';
//test

mapboxgl.accessToken =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

export const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  countries: 'us',
  region: 'ca',
  limit: 3,
  bbox: [-118.94469075, 32.79959037, -117.64637388, 34.82329919], // changed this to la county boundaries
  mapboxgl: mapboxgl,
  language: 'en, es',
});
